import React, { useState, useEffect } from 'react'
import {
  Form,
  Input,
  Button,
  Upload,
  Row,
  Col,
  DatePicker,
  Layout,
  Typography,
  Select,
  message,
  Modal,
  Tabs,
} from 'antd'
import { CheckCircleOutlined, UploadOutlined } from '@ant-design/icons'
import { useLocation, useNavigate } from 'react-router-dom'
import './StudentRegistrationPage.css'
import QRCodeImg from '../../../Assets/QRCode.jpeg'
import Footer from '../../CommonComponents/AdminCommonCom/Footer'
import axios from 'axios'
import {
  CheckEmailWhatsappAPI,
  CheckWhatsAppNumber,
  DistrictMaster,
  RegistrationAPI,
  StateMaster,
  TalukaMaster,
  VerifyWhatsAppOtp,
} from '../../../AllAPI/StudentAPI'
import {
  BranchMaster,
  GetCasteMaster,
  GetCasteMasterById,
  GetFeeAmountMaster,
  GetReligionMaster,
  GetSubCasteMasterById,
} from '../../../AllAPI/AdminAPI'
import hostelLogo from '../../../Assets/logo.png'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'
import NamunaForm from '../../../Assets/NamunaForm.jpg'

const { Header, Content } = Layout
const { Title } = Typography
const { Option } = Select

export default function StudentRegistrationPage3() {
  const navigate = useNavigate()
  const [step, setStep] = useState(1)
  const [payMode, setPayMode] = useState('')
  const [amount, setAmount] = useState('')
  const [taxId, setTaxId] = useState('')
  const [taxImg, setTaxImg] = useState(null)
  const [paymentDate, setPaymentDate] = useState('')

  const location = useLocation()
  const formData = location.state?.formData || {}
  const formDataFromStorage = JSON.parse(
    localStorage.getItem('studentRegData') || '{}',
  )

  const BranchId = formData.branch_id || formDataFromStorage.branch_id

  const [branchName, setBranchName] = useState('')
  const currentYear = new Date().getFullYear()

  const [castes, setCastes] = useState([])
  // const [subCastes, setSubCastes] = useState([])
  const [religions, setReligions] = useState([])
  const [states, setStates] = useState([])
  const [districts, setDistricts] = useState([])
  const [talukas, setTalukas] = useState([])

  const [loadingCastes, setLoadingCastes] = useState(false)
  const [loadingDistricts, setLoadingDistricts] = useState(false)
  const [loadingTalukas, setLoadingTalukas] = useState(false)

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await axios.get(BranchMaster)
        const branches = response.data

        // find matching branch
        const matched = branches.find(
          (item) => String(item.branch_id) === String(BranchId),
        )

        if (matched) {
          setBranchName(matched.branch_name)
        }
      } catch (err) {
        console.error('Error fetching branches:', err)
      }
    }

    fetchBranches()
  }, [BranchId])

  useEffect(() => {
    const fetchAmount = async () => {
      try {
        const res = await axios.get(
          `${GetFeeAmountMaster}/${BranchId}/${currentYear}`,
        )
        setAmount(res.data[0].fee_amount)
      } catch (err) {
        console.error(err)
        toast.error('Failed to fetch amount')
      }
    }

    fetchAmount()
  }, [])

  // =============================
  // STUDENT INFO STATES
  // =============================
  const [firstName, setFirstName] = useState('')
  const [middleName, setMiddleName] = useState('')
  const [lastName, setLastName] = useState('')
  const [mobileNo, setMobileNo] = useState('')
  const [mobileError, setMobileError] = useState('')

  const [wtsNo, setWtsNo] = useState('')
  const [wtsNoError, setWtsNoError] = useState('')
  const [otp, setOtp] = useState('')
  const [otpDemo, setOtpDemo] = useState('')
  const [isOtpSent, setIsOtpSent] = useState(false)
  const [timeLeft, setTimeLeft] = useState(0)
  const [isVerified, setIsVerified] = useState(false)

  const [emailId, setEmailId] = useState('')
  const [dob, setDob] = useState(null)
  const [casteId, setCasteId] = useState(null)
  // const [subCasteId, setSubCasteId] = useState(null)
  const [religionId, setReligionId] = useState(null)
  const [bloodGroup, setBloodGroup] = useState(null)

  const [profilePic, setProfilePic] = useState('')
  const [aadharImg, setAadharImg] = useState('')
  const [casteIncomeCert, setCasteIncomeCert] = useState('')
  const [recommLetter, setRecommLetter] = useState('')
  const [curYearAdReceipt, setCurYearAdReceipt] = useState('')

  // =============================
  // ADDRESS STATES
  // =============================
  const [address, setAddress] = useState('')
  const [pin, setPin] = useState('')
  const [village, setVillage] = useState('')
  const [stateId, setStateId] = useState(null)
  const [districtId, setDistrictId] = useState(null)
  const [talukaId, setTalukaId] = useState(null)

  // =============================
  // ACADEMIC STATES
  // =============================
  const [lastAttendedCollege, setLastAttendedCollege] = useState('')
  const [highestQualification, setHighestQualification] = useState('')
  const [specificDegree, setSpecificDegree] = useState('')
  const [aggregatePercentage, setAggregatePercentage] = useState('')
  const [monthYearOfPassing, setMonthYearOfPassing] = useState('')
  const [currentCollege, setCurrentCollege] = useState('')
  const [courseName, setCourseName] = useState('')
  const [totalCourseDuration, setTotalCourseDuration] = useState('')
  const [remainingCourseDuration, setRemainingCourseDuration] = useState('')

  // =============================
  // FATHER INFO STATES
  // =============================
  const [fatherFirstName, setFatherFirstName] = useState('')
  const [fatherMiddleName, setFatherMiddleName] = useState('')
  const [fatherLastName, setFatherLastName] = useState('')
  const [fatherMob, setFatherMob] = useState('')
  const [fatherMobileError, setFatherMobileError] = useState('')
  const [fatherAge, setFatherAge] = useState('')
  const [fatherOccupation, setFatherOccupation] = useState('')
  const [familyMembers, setFamilyMembers] = useState('')

  // =============================
  // MOTHER INFO STATES
  // =============================
  const [motherFirstName, setMotherFirstName] = useState('')
  const [motherMiddleName, setMotherMiddleName] = useState('')
  const [motherLastName, setMotherLastName] = useState('')
  const [motherMob, setMotherMob] = useState('')
  const [motherMobileError, setMotherMobileError] = useState('')
  const [emergencyMobileError, setEmergencyMobileError] = useState('')
  const [motherAge, setMotherAge] = useState('')
  const [motherOccupation, setMotherOccupation] = useState('')

  const [emergencyName, setEmergencyName] = useState('')
  const [emergencyMobile, setEmergencyMobile] = useState('')

  // =======Tab Section=========
  const [activeTab, setActiveTab] = useState('1')
  const [chairmanName, setChairmanName] = useState('')
  const [chairmanMobile, setChairmanMobile] = useState('')
  const [chairmanMobileError, setChairmanMobileError] = useState('')
  const [chairmanVillage, setChairmanVillage] = useState('')

  const [localRefName, setLocalRefName] = useState('')
  const [localRefMobile, setLocalRefMobile] = useState('')
  const [localRefMobileError, setLocalRefMobileError] = useState('')
  const [localRefRelation, setLocalRefRelation] = useState('')

  const [localGuardianName, setLocalGuardianName] = useState('')
  const [localGuardianMobile, setLocalGuardianMobile] = useState('')
  const [localGuardianMobileError, setLocalGuardianMobileError] = useState('')
  const [localGuardianAddress, setLocalGuardianAddress] = useState('')

  const [loading, setLoading] = useState(false)

  // ===============WHATS APP VERIFICATION======================
  const sendOtp = async () => {
    if (!/^[6-9]\d{9}$/.test(wtsNo)) {
      toast.error('Enter valid WhatsApp number')
      return
    }

    try {
      const res = await axios.post(CheckWhatsAppNumber, {
        wh_mobile: wtsNo,
      })

      // if (res.data === 'SEND') {
      //   toast.success('OTP sent successfully')
      //   setIsOtpSent(true)
      //   setTimeLeft(30)
      //   setOtp('')
      //   setIsVerified(false)
      // }

      if (res.data.message === 'SEND') {
        toast.success('OTP sent successfully')
        setIsOtpSent(true)
        setTimeLeft(30)
        setOtpDemo(res.data.otp)
        setOtp('')
        setIsVerified(false)
      }

      if (res.data === 'VERIFIED') {
        toast.success('WhatsApp number already verified')
        setIsVerified(true)
        setIsOtpSent(false)
        setTimeLeft(0)
      }
    } catch (err) {
      toast.error('Failed to send OTP')
    }
  }

  useEffect(() => {
    if (timeLeft === 0) return

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1)
    }, 1000)

    return () => clearInterval(timer)
  }, [timeLeft])

  useEffect(() => {
    if (timeLeft === 0) {
      setIsOtpSent(false) // hide OTP + timer
    }
  }, [timeLeft])

  const verifyOtp = async () => {
    try {
      const res = await axios.post(VerifyWhatsAppOtp, {
        wh_mobile: wtsNo,
        otp: otp,
      })

      if (res.data === 'VERIFIED') {
        toast.success('WhatsApp number verified!')
        setIsVerified(true)
        setIsOtpSent(false)
        setTimeLeft(0)
      } else if (res.data === 'OTP_EXPIRY') {
        toast.warn('OTP has been expired!')
        setIsVerified(false)
        setIsOtpSent(false)
        setTimeLeft(0)
      } else {
        toast.error('Invalid OTP')
      }
    } catch (err) {
      toast.error('OTP verification failed')
    }
  }

  // ==========================================

  //  Fetch all religions when page loads
  useEffect(() => {
    axios.get(GetReligionMaster).then((res) => {
      setReligions(res.data)
    })
  }, [])

  const percentageOptions = Array.from({ length: 100 }, (_, i) => ({
    label: `${i + 1}%`,
    value: i + 1,
  }))

  const durationOptions = Array.from({ length: 5 }, (_, i) => ({
    label: `${i + 1} year`,
    value: `${i + 1} year`,
  }))

  const handleReligionChange = (religionId) => {
    setReligionId(religionId)

    // RESET SubCaste  when Caste changes
    setCasteId(null)
    setCastes([])

    setLoadingCastes(true)

    axios
      .get(`${GetCasteMasterById}/${religionId}`)
      .then((res) => {
        setCastes(res.data)
      })
      .finally(() => setLoadingCastes(false))
  }

  const handleCasteChange = (casteId) => {
    setCasteId(casteId)
  }

  //  Fetch all states when page loads
  useEffect(() => {
    axios.get(StateMaster).then((res) => {
      setStates(res.data)
    })
  }, [])

  //  Fetch districts when state changes
  const handleStateChange = (stateId) => {
    setStateId(stateId)

    // RESET district & taluka when state changes
    setDistrictId(null)
    setTalukaId(null)
    setDistricts([])
    setTalukas([])

    setLoadingDistricts(true)

    axios
      .get(`${DistrictMaster}/${stateId}`)
      .then((res) => {
        setDistricts(res.data)
      })
      .finally(() => setLoadingDistricts(false))
  }

  //  Fetch talukas when district changes
  const handleDistrictChange = (districtId) => {
    setDistrictId(districtId)
    // RESET only taluka when district changes
    setTalukaId(null)
    setTalukas([])

    setLoadingTalukas(true)

    axios
      .get(`${TalukaMaster}/${stateId}/${districtId}`)
      .then((res) => {
        setTalukas(res.data)
      })
      .finally(() => setLoadingTalukas(false))
  }

  // ==========SAVE DATA==========
  const handleSubmit = async () => {
    if (!dob) {
      toast.error('Please select date of birth')
      return
    }

    const DOB = dob.format('YYYY-MM-DD')
    const fd = new FormData()

    fd.append('year', currentYear)
    fd.append('branch_id', parseInt(BranchId))
    fd.append('s_fname', firstName)
    fd.append('s_mname', middleName)
    fd.append('s_lname', lastName)
    fd.append('mobile', mobileNo)
    fd.append('wh_mobile', wtsNo)
    fd.append('email', emailId)
    fd.append('date_of_birth', DOB)
    fd.append('cast_id', parseInt(casteId))
    // fd.append('subcast_id', parseInt(subCasteId))
    fd.append('religion_id', parseInt(religionId))
    fd.append('blood_grp', bloodGroup)
    fd.append('address', address)
    fd.append('pin', pin)
    fd.append('village', village)
    fd.append('state', stateId)
    fd.append('district', districtId)
    fd.append('taluka', talukaId)

    fd.append('last_attended_clg_name', lastAttendedCollege)
    fd.append('highest_qualification', highestQualification)
    fd.append('specific_degree', specificDegree)
    fd.append('aggre_percentage', aggregatePercentage)
    fd.append('month_year_of_passing', monthYearOfPassing)
    fd.append('curr_yr_clg_name', currentCollege)
    fd.append('course_name', courseName)
    fd.append('total_course_duration', totalCourseDuration)
    fd.append('remaining_course_duration', remainingCourseDuration)

    fd.append('father_fname', fatherFirstName)
    fd.append('father_mname', fatherMiddleName)
    fd.append('father_lname', fatherLastName)
    fd.append('father_mob', fatherMob)
    fd.append('father_age', fatherAge)
    fd.append('father_occ', fatherOccupation)
    fd.append('total_family_mamber', familyMembers)
    fd.append('mother_fname', motherFirstName)
    fd.append('mother_mname', motherMiddleName)
    fd.append('mother_lname', motherLastName)
    fd.append('mother_mob', motherMob)
    fd.append('mother_age', motherAge)
    fd.append('mother_occ', motherOccupation)

    fd.append('emergency_name', emergencyName)
    fd.append('emergency_contact', emergencyMobile)

    fd.append('chairman_name', chairmanName)
    fd.append('chairman_mob', chairmanMobile)
    fd.append('chairman_village', chairmanVillage)
    fd.append('reference_name', localRefName)
    fd.append('reference_mobile', localRefMobile)
    fd.append('reference_relation', localRefRelation)

    fd.append('local_guardian_name', localGuardianName)
    fd.append('local_guardian_mobile', localGuardianMobile)
    fd.append('local_guardian_address', localGuardianAddress)

    // Files
    fd.append('register_payment_year', new Date().getFullYear())
    fd.append('s_pic', profilePic)
    fd.append('s_aadhar', aadharImg)
    fd.append('cast_income_cert', casteIncomeCert)
    fd.append('recommendation_letter', recommLetter)
    fd.append('clg_add_receipt', curYearAdReceipt)

    // Payment
    fd.append('register_pay_mode', payMode)
    fd.append('register_pay_amount', amount)
    fd.append('register_tax_id', taxId)
    fd.append('register_pay_date', paymentDate?.format('YYYY-MM-DD'))
    fd.append('register_tax_image', taxImg)

    try {
      setLoading(true)
      const res = await axios.post(`${RegistrationAPI}`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      if (res.data == 'ERROR') {
        toast.warn('Error Occurred!!')
      } else if (res.data == 'SAVED') {
        toast.success('Registration Successful, Waiting for admin approval..!')
        navigate('/student/login')
      }
    } catch (err) {
      toast.error('Error while submitting form')
    } finally {
      setLoading(false) // 👉 STOP LOADER
    }
  }

  // ========Documents===========
  const [profilePicFileList, setProfilePicFileList] = useState([])
  const [aadharFileList, setAadharFileList] = useState([])
  const [casteFileList, setCasteFileList] = useState([])
  const [recommFileList, setRecommFileList] = useState([])
  const [receiptFileList, setReceiptFileList] = useState([])
  const [taxFileList, setTaxFileList] = useState([])

  const handleImageUpload1 = ({ fileList }) => {
    const updatedList = fileList.map((file) => ({
      ...file,
      status: 'done',
    }))

    setProfilePicFileList(updatedList)

    const file = updatedList?.[0]?.originFileObj
    if (file) {
      setProfilePic(file)
    }
  }

  const handleImageUpload2 = ({ fileList }) => {
    const updatedList = fileList.map((file) => ({
      ...file,
      status: 'done',
    }))

    setAadharFileList(updatedList)

    const file = updatedList?.[0]?.originFileObj
    if (file) {
      setAadharImg(file)
    }
  }

  const handleImageUpload3 = ({ fileList }) => {
    const updatedList = fileList.map((file) => ({
      ...file,
      status: 'done',
    }))

    setCasteFileList(updatedList)

    const file = updatedList?.[0]?.originFileObj
    if (file) {
      setCasteIncomeCert(file)
    }
  }

  const handleImageUpload4 = ({ fileList }) => {
    const updatedList = fileList.map((file) => ({
      ...file,
      status: 'done',
    }))

    setRecommFileList(updatedList)

    const file = updatedList?.[0]?.originFileObj
    if (file) {
      setRecommLetter(file)
    }
  }

  const handleImageUpload5 = ({ fileList }) => {
    const updatedList = fileList.map((file) => ({
      ...file,
      status: 'done',
    }))

    setReceiptFileList(updatedList)

    const file = updatedList?.[0]?.originFileObj
    if (file) {
      setCurYearAdReceipt(file)
    }
  }

  const handleImageUpload6 = ({ fileList }) => {
    const updatedList = fileList.map((file) => ({
      ...file,
      status: 'done',
    }))

    setTaxFileList(updatedList)

    const file = updatedList?.[0]?.originFileObj
    if (file) {
      setTaxImg(file)
    }
  }

  // ===== VALIDATE STEPS=========

  const validateRequiredFields = (fields) => {
    for (const field of fields) {
      if (!field.value) {
        toast.warn(`Please fill ${field.label}`)
        return false
      }
    }
    return true
  }

  const validateStep1 = () => {
    return validateRequiredFields([
      { label: 'First Name', value: firstName },
      { label: 'Middle Name', value: middleName },
      { label: 'Last Name', value: lastName },
      { label: 'Date of Birth', value: dob },
      { label: 'Caste', value: casteId },
      // { label: 'Sub Caste', value: subCasteId },
      { label: 'Religion', value: religionId },
      { label: 'Blood Group', value: bloodGroup },
      { label: 'WhatsApp Number', value: wtsNo },
      { label: 'Mobile Number', value: mobileNo },
      { label: 'Email', value: emailId },

      { label: 'Address', value: address },
      { label: 'Village', value: village },
      { label: 'State', value: stateId },
      { label: 'District', value: districtId },
      { label: 'Taluka', value: talukaId },
      { label: 'Pin Code', value: pin },

      { label: "Father's First Name", value: fatherFirstName },
      { label: "Father's Middle Name", value: fatherMiddleName },
      { label: "Father's Last Name", value: fatherLastName },
      { label: "Father's Mobile", value: fatherMob },
      { label: "Father's Age", value: fatherAge },
      { label: "Father's Occupation", value: fatherOccupation },
      { label: 'Total Family Members', value: familyMembers },

      { label: "Mother's First Name", value: motherFirstName },
      { label: "Mother's Middle Name", value: motherMiddleName },
      { label: "Mother's Last Name", value: motherLastName },
      { label: "Mother's Mobile", value: motherMob },
      { label: "Mother's Age", value: motherAge },
      { label: "Mother's Occupation", value: motherOccupation },

      { label: 'Emergency Name', value: emergencyName },
      { label: 'Emergency Mobile', value: emergencyMobile },

      { label: 'Temple Chairman Name', value: chairmanName },
      { label: 'Temple Chairman Mobile', value: chairmanMobile },
      { label: 'Temple Chairman Village', value: chairmanVillage },

      { label: 'Local Reference Name', value: localRefName },
      { label: 'Local Reference Mobile', value: localRefMobile },
      { label: 'Local Reference Relation', value: localRefRelation },

      { label: 'Local Guardian Name', value: localGuardianName },
      { label: 'Local Guardian Mobile', value: localGuardianMobile },
      { label: 'Local Guardian Address', value: localGuardianAddress },
    ])
  }

  const validateStep2 = () => {
    return validateRequiredFields([
      { label: 'Last Attended College', value: lastAttendedCollege },
      { label: 'Highest Qualification', value: highestQualification },
      { label: 'Specific Degree', value: specificDegree },
      { label: 'Current College', value: currentCollege },
      { label: 'Aggregate Percentage', value: aggregatePercentage },
      { label: 'Month/Year Of Passing', value: monthYearOfPassing },
      { label: 'Course Name', value: courseName },
      { label: 'Total Course Duration', value: totalCourseDuration },
      { label: 'Remaining Course Duration', value: remainingCourseDuration },
    ])
  }

  const validateStep3 = () => {
    return validateRequiredFields([
      { label: 'Profile Photo', value: profilePic },
      { label: 'Aadhar Card', value: aadharImg },
      { label: 'Caste Income Certificate', value: casteIncomeCert },
      { label: 'Recommendation Letter', value: recommLetter },
      { label: 'Current Year Admission Receipt', value: curYearAdReceipt },
    ])
  }

  const validateStep4 = () => {
    if (!payMode) {
      toast.warn('Please select payment mode')
      return false
    }

    if (payMode === '1' || payMode === '2') {
      return validateRequiredFields([
        { label: 'Amount', value: amount },
        {
          label: payMode === '1' ? 'Receipt ID' : 'UPI Transaction ID',
          value: taxId,
        },
        { label: 'Payment Date', value: paymentDate },
        {
          label: payMode === '1' ? 'Receipt Image' : 'Payment Screenshot',
          value: taxImg,
        },
      ])
    }

    return true
  }

  const verifyEmailWhatsapp = async () => {
    try {
      const res = await axios.post(CheckEmailWhatsappAPI, {
        email: emailId,
        wh_mobile: wtsNo,
        year: currentYear,
      })

      if (res.data === 'EMAILEXIST') {
        toast.warn('The Email Id is already registered')
        return false
      }

      if (res.data === 'WHMOBILEEXIST') {
        toast.warn('The WhatsApp number is already registered')
        return false
      }

      if (res.data === 'NOTEXIST') {
        return true
      }

      toast.error('Unexpected response from server')
      return false
    } catch (error) {
      toast.error('Something went wrong while verifying!')
      return false
    }
  }

  const goNext = async () => {
    if (step === 1) {
      if (!validateStep1()) return
      if (activeTab === '1') {
        const isValid = await verifyEmailWhatsapp()
        if (!isValid) return
      }
    }

    // For steps 2,3,4 continue normal validation
    if (step === 2 && !validateStep2()) return
    if (step === 3 && !validateStep3()) return
    if (step === 4 && !validateStep4()) return

    setStep(step + 1)
  }

  const goBack = () => setStep(step - 1)

  // Auto-update father's name when student middle name changes
  useEffect(() => {
    if (middleName) {
      setFatherFirstName(middleName)
      setMotherMiddleName(middleName)
    }
  }, [middleName])

  // Auto-update father's last name when student last name changes
  useEffect(() => {
    if (lastName) {
      setFatherLastName(lastName)
      setMotherLastName(lastName)
    }
  }, [lastName])

  const handleReset = () => {
    setPayMode('')
    setAmount('100')
    setTaxId('')
    setTaxImg(null)
    setPaymentDate('')
  }

  const goNextTab = async () => {
    //  BLOCK if WhatsApp is not verified on first tab
    // if (activeTab === '1' && !isVerified) {
    //   toast.warn('Please verify WhatsApp number first')
    //   return
    // }

    //  call API only on first tab
    if (activeTab === '1') {
      const isValid = await verifyEmailWhatsapp()
      if (!isValid) return
    }

    //  Move to next tab
    setActiveTab((prev) => (Number(prev) + 1).toString())
  }

  const goPrevTab = () => {
    setActiveTab((prev) => (Number(prev) - 1).toString())
  }

  const disabledDate = (current) => {
    // Disable dates after (today - 16 years)
    return current && current > dayjs().subtract(16, 'year').endOf('day')
  }

  return (
    <Layout className="registration-layout">
      {/* 🔹 Navbar/Header */}
      <Header
        className="registration-header"
        style={{ backgroundColor: '#235784' }}
      >
        <div className="logo-container">
          <img src={hostelLogo} alt="Logo" className="company-logo" />
          <span className="company-name">{branchName}</span>
        </div>
        <div className="nav-links">
          <Button
            type="link"
            onClick={() => navigate('/student-login')}
            style={{ border: '1px solid white', color: 'white' }}
          >
            Login
          </Button>
        </div>
      </Header>

      {/* 🔹 Main Content */}
      <Content className="registration-content">
        <div className="registration-form-container mb-5">
          <div className="header-row">
            <h2 className="page-title">
              Student Registration Form (ವಿದ್ಯಾರ್ಥಿ ನೋಂದಣಿ ನಮೂನೆ)
            </h2>
          </div>

          {step === 1 && (
            <>
              <Tabs
                activeKey={activeTab}
                onChange={() => {}} // disable manual click
                type="card"
              >
                <Tabs.TabPane tab="Student Info" key="1">
                  {/* ====== Student Info ====== */}
                  <Row
                    gutter={[16, 0]}
                    className="my-2 p-2 rounded border"
                    style={{ backgroundColor: '#f2f7fdff' }}
                  >
                    <Col xs={24} sm={8} md={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="First Name (ಮೊದಲ ಹೆಸರು)"
                        rules={[{ required: true }]}
                      >
                        <Input
                          placeholder="Enter first name"
                          size="large"
                          value={firstName}
                          onChange={(e) => setFirstName(e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8} md={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Middle Name (ಮಧ್ಯದ ಹೆಸರು)"
                        rules={[{ required: true }]}
                      >
                        <Input
                          placeholder="Enter middle name"
                          size="large"
                          value={middleName}
                          onChange={(e) => setMiddleName(e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8} md={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Last Name (ಕೊನೆಯ ಹೆಸರು)"
                        rules={[{ required: true }]}
                      >
                        <Input
                          placeholder="Enter last name"
                          size="large"
                          value={lastName}
                          onChange={(e) => setLastName(e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={6} md={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Date of Birth (ಹುಟ್ಟಿದ ದಿನಾಂಕ)"
                        rules={[
                          {
                            required: true,
                            message: 'Please select date of birth',
                          },
                          {
                            validator: (_, value) => {
                              if (!value) return Promise.resolve()
                              const isValid = value.isBefore(
                                dayjs().subtract(16, 'year'),
                              )
                              return isValid
                                ? Promise.resolve()
                                : Promise.reject(
                                    'Age must be at least 16 years',
                                  )
                            },
                          },
                        ]}
                      >
                        <DatePicker
                          style={{ width: '100%' }}
                          format="DD-MM-YYYY"
                          value={dob}
                          onChange={(date) => setDob(date)}
                          size="large"
                          disabledDate={disabledDate}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={6} md={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Religion (ಧರ್ಮ)"
                        rules={[
                          {
                            required: true,
                            message: 'Please select a religion',
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select Religion"
                          size="large"
                          value={religionId}
                          onChange={handleReligionChange}
                        >
                          {religions.map((r) => (
                            <Option key={r.id} value={r.id}>
                              {r.religion_name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={6} md={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Caste (ಜಾತಿ)"
                        rules={[
                          { required: true, message: 'Please select a caste' },
                        ]}
                      >
                        <Select
                          placeholder="Select Caste"
                          size="large"
                          value={casteId}
                          onChange={handleCasteChange}
                          allowClear
                          disabled={!religionId}
                          loading={loadingCastes}
                        >
                          {castes.map((c) => (
                            <Option key={c.cast_id} value={c.cast_id}>
                              {c.cast_name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={6} md={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Blood Group (ರಕ್ತದ ಗುಂಪು)"
                        rules={[
                          {
                            required: true,
                            message: 'Please select blood group',
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select blood group"
                          size="large"
                          value={bloodGroup}
                          onChange={(value) => setBloodGroup(value)}
                        >
                          <Select.Option value="A+">A+</Select.Option>
                          <Select.Option value="A-">A-</Select.Option>
                          <Select.Option value="B+">B+</Select.Option>
                          <Select.Option value="B-">B-</Select.Option>
                          <Select.Option value="O+">O+</Select.Option>
                          <Select.Option value="O-">O-</Select.Option>
                          <Select.Option value="AB+">AB+</Select.Option>
                          <Select.Option value="AB-">AB-</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={6} md={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="What's App No. (ಆಪ್ ಸಂಖ್ಯೆ ಏನು?)"
                        validateStatus={wtsNoError ? 'error' : ''}
                        help={wtsNoError}
                        rules={[
                          {
                            required: true,
                            message: "Please enter what's app number",
                          },
                          {
                            pattern: /^[6-9]\d{9}$/,
                            message:
                              'Please enter a valid 10-digit mobile number',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter 10-digit mobile number"
                          size="large"
                          maxLength={10}
                          value={wtsNo}
                          onChange={(e) => {
                            const value = e.target.value
                              .replace(/\D/g, '')
                              .slice(0, 10)
                            setWtsNo(value)

                            if (value.length < 10) {
                              setWtsNoError('Mobile number must be 10 digits')
                            } else {
                              setWtsNoError('')
                            }
                          }}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault() // ⛔ Prevents non-numeric input
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>

                    {/* <Col xs={24} sm={6} md={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="What's App No. (ಆಪ್ ಸಂಖ್ಯೆ ಏನು?)"
                        rules={[
                          {
                            required: true,
                            message: "Please enter what's app number",
                          },
                          {
                            pattern: /^[6-9]\d{9}$/,
                            message:
                              'Please enter a valid 10-digit mobile number',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter 10-digit mobile number"
                          size="large"
                          maxLength={10}
                          value={wtsNo}
                          onChange={(e) => setWtsNo(e.target.value)}
                          suffix={
                            isVerified ? (
                              <CheckCircleOutlined
                                style={{ color: 'green', fontSize: 18 }}
                              />
                            ) : (
                              <span
                                onClick={sendOtp}
                                style={{
                                  color: '#1677ff',
                                  cursor: 'pointer',
                                  fontSize: 14,
                                  lineHeight: '1',
                                }}
                              >
                                Verify
                              </span>
                            )
                          }
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) e.preventDefault()
                          }}
                        />
                      </Form.Item>
                    </Col> */}

                    {/* {isOtpSent && (
                      <>

                        <Col xs={24} sm={3}>
                          <Form.Item
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            className="otpInput"
                          >
                            <Input
                              size="large"
                              placeholder="Enter OTP"
                              value={otp}
                              maxLength={6}
                              onChange={(e) => setOtp(e.target.value)}
                            />
                            <div
                              style={{
                                marginTop: 5,
                                fontSize: 12,
                                color: 'red',
                              }}
                            >
                              OTP expires in {timeLeft} s
                            </div>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={2}>
                          <Form.Item
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            className="otpInput"
                          >
                            <Button type="primary" onClick={verifyOtp}>
                              Verify OTP
                            </Button>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={1}></Col>
                        
                      </>
                    )} */}

                    <Col xs={24} sm={6} md={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Mobile (ಮೊಬೈಲ್)"
                        validateStatus={mobileError ? 'error' : ''}
                        help={mobileError}
                        rules={[
                          {
                            required: true,
                            message: 'Please enter mobile number',
                          },
                          {
                            pattern: /^[6-9]\d{9}$/,
                            message:
                              'Please enter a valid 10-digit mobile number',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter 10-digit mobile number"
                          size="large"
                          maxLength={10}
                          value={mobileNo}
                          onChange={(e) => {
                            const value = e.target.value
                              .replace(/\D/g, '')
                              .slice(0, 10)
                            setMobileNo(value)

                            if (value.length < 10) {
                              setMobileError('Mobile number must be 10 digits')
                            } else {
                              setMobileError('')
                            }
                          }}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault() // ⛔ Prevents non-numeric input
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={6} md={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Email (ಇಮೇಲ್)"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter email address',
                          },
                          {
                            type: 'email',
                            message: 'Please enter a valid email address',
                          },
                          {
                            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/,
                            message: 'Please enter a properly formatted email',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter email address"
                          size="large"
                          value={emailId}
                          onChange={(e) => setEmailId(e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row justify="center" gutter={16}>
                    <Col>
                      <Button onClick={() => navigate('/student/register')}>
                        Back
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        onClick={goNextTab}
                        type="primary"
                        disabled={!!mobileError || !!wtsNoError}
                      >
                        Next
                      </Button>
                    </Col>
                  </Row>
                </Tabs.TabPane>

                <Tabs.TabPane tab="Address Information" key="2">
                  {/* ====== Address Details ====== */}
                  <Title level={4}>
                    Address Information{' '}
                    <span style={{ fontWeight: 'normal' }}>(ವಿಳಾಸ ಮಾಹಿತಿ)</span>
                    -
                  </Title>
                  <Row
                    gutter={[16, 0]}
                    className="my-2 p-2 rounded border"
                    style={{ backgroundColor: '#f2f7fdff' }}
                  >
                    <Col xs={24} sm={18}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Address (ವಿಳಾಸ)"
                        rules={[{ required: true }]}
                      >
                        <Input.TextArea
                          rows={3}
                          placeholder="Full address"
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={6}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="City/Village (ನಗರ/ಗ್ರಾಮ)"
                        rules={[{ required: true }]}
                      >
                        <Input
                          placeholder="City/Village"
                          size="large"
                          value={village}
                          onChange={(e) => setVillage(e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={6}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="State (ರಾಜ್ಯ)"
                        rules={[
                          { required: true, message: 'Please select a state' },
                        ]}
                      >
                        <Select
                          placeholder="Select State"
                          size="large"
                          value={stateId}
                          onChange={handleStateChange}
                          allowClear
                        >
                          {states.map((s) => (
                            <Option key={s.id} value={s.id}>
                              {s.stateenname}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={6}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="District (ಜಿಲ್ಲೆ)"
                        rules={[
                          {
                            required: true,
                            message: 'Please select a district',
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select District"
                          size="large"
                          value={districtId}
                          onChange={handleDistrictChange}
                          disabled={!stateId}
                          loading={loadingDistricts}
                          allowClear
                        >
                          {districts.map((d) => (
                            <Option key={d.id} value={d.id}>
                              {d.districtenname}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={6}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Taluka (ತಾಲೂಕು)"
                        rules={[
                          { required: true, message: 'Please select a taluka' },
                        ]}
                      >
                        <Select
                          placeholder="Select Taluka"
                          size="large"
                          disabled={!districtId}
                          loading={loadingTalukas}
                          allowClear
                          value={talukaId}
                          onChange={setTalukaId}
                        >
                          {talukas.map((t) => (
                            <Option key={t.id} value={t.id}>
                              {t.talukaenname}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={6}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Pin Code (ಪಿನ್ ಕೋಡ್)"
                        rules={[
                          { required: true, message: 'Please enter pin code' },
                          {
                            pattern: /^[0-9]{6}$/,
                            message: 'Pin code must be 6 digits',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter 6-digit Pin Code"
                          size="large"
                          value={pin}
                          onChange={(e) => setPin(e.target.value)}
                          maxLength={6}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault() // blocks any non-numeric key
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center" gutter={16}>
                    <Col>
                      <Button onClick={goPrevTab}>Back</Button>
                    </Col>
                    <Col>
                      <Button onClick={goNextTab} type="primary">
                        Next
                      </Button>
                    </Col>
                  </Row>
                </Tabs.TabPane>

                <Tabs.TabPane tab="Parent Information" key="3">
                  {/* ====== Father's Details ====== */}
                  <Title level={4}>
                    Father’s Information{' '}
                    <span style={{ fontWeight: 'normal' }}>(ತಂದೆಯ ಮಾಹಿತಿ)</span>
                    -
                  </Title>
                  <Row
                    gutter={[16, 0]}
                    className="my-2 p-2 rounded border"
                    style={{ backgroundColor: '#f2f7fdff' }}
                  >
                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="First Name (ಮೊದಲ ಹೆಸರು)"
                        rules={[{ required: true }]}
                      >
                        <Input
                          size="large"
                          value={fatherFirstName}
                          onChange={(e) => setFatherFirstName(e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Middle Name (ಮಧ್ಯದ ಹೆಸರು)"
                        rules={[{ required: true }]}
                      >
                        <Input
                          size="large"
                          value={fatherMiddleName}
                          onChange={(e) => setFatherMiddleName(e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Last Name (ಕೊನೆಯ ಹೆಸರು)"
                        rules={[{ required: true }]}
                      >
                        <Input
                          size="large"
                          value={fatherLastName}
                          onChange={(e) => setFatherLastName(e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={6}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        validateStatus={fatherMobileError ? 'error' : ''}
                        help={fatherMobileError}
                        label="Mobile (ಮೊಬೈಲ್)"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter mobile number',
                          },
                          {
                            pattern: /^[6-9]\d{9}$/,
                            message:
                              'Please enter a valid 10-digit mobile number',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter 10-digit mobile number"
                          size="large"
                          maxLength={10}
                          value={fatherMob}
                          onChange={(e) => {
                            const value = e.target.value
                              .replace(/\D/g, '')
                              .slice(0, 10)
                            setFatherMob(value)

                            if (value.length < 10) {
                              setFatherMobileError(
                                'Mobile number must be 10 digits',
                              )
                            } else {
                              setFatherMobileError('')
                            }
                          }}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault() // ⛔ Prevents non-numeric input
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={6}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Age (ವಯಸ್ಸು)"
                        rules={[
                          { required: true, message: 'Please enter age' },
                          {
                            pattern: /^(?:[1-9][0-9]?|100)$/,
                            message: 'Please enter a valid age (1–100)',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter age"
                          size="large"
                          value={fatherAge}
                          onChange={(e) => setFatherAge(e.target.value)}
                          maxLength={3}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault() // ⛔ blocks non-numeric input
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={6}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Occupation (ಉದ್ಯೋಗ)"
                        rules={[
                          {
                            required: true,
                            message: 'Please select occupation',
                          },
                        ]}
                      >
                        <Select
                          size="large"
                          value={fatherOccupation}
                          onChange={(value) => setFatherOccupation(value)}
                          placeholder="Select Occupation"
                        >
                          <Select.Option value="Business">
                            Business
                          </Select.Option>
                          <Select.Option value="House Wife">
                            House Wife
                          </Select.Option>
                          <Select.Option value="Farmer">Farmer</Select.Option>
                          <Select.Option value="Professional">
                            Professional
                          </Select.Option>
                          <Select.Option value="Trader">Trader</Select.Option>
                          <Select.Option value="Private Job">
                            Private Job
                          </Select.Option>
                          <Select.Option value="Govt Job">
                            Govt Job
                          </Select.Option>
                          <Select.Option value="Retired">Retired</Select.Option>
                          <Select.Option value="Unemployed">
                            Unemployed
                          </Select.Option>
                          <Select.Option value="Teacher">Teacher</Select.Option>
                          <Select.Option value="Doctor">Doctor</Select.Option>
                          <Select.Option value="Advocate">
                            Advocate
                          </Select.Option>
                          <Select.Option value="Others">Others</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={6}>
                      <Form.Item>
                        <div
                          style={{
                            marginBottom: 9,
                            paddingTop: 7,
                            fontWeight: 500,
                          }}
                        >
                          Total Family Members &nbsp;
                          <span>(ಒಟ್ಟು ಕುಟುಂಬ ಸದಸ್ಯರು)</span>
                        </div>

                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          rules={[
                            {
                              required: true,
                              message: 'Please enter total family members',
                            },
                            {
                              pattern: /^[0-9]+$/,
                              message: 'Please enter a valid number',
                            },
                          ]}
                        >
                          <Input
                            placeholder="e.g. 4"
                            size="large"
                            maxLength={2}
                            value={familyMembers}
                            onChange={(e) => setFamilyMembers(e.target.value)}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault() // ⛔ prevents non-numeric input
                              }
                            }}
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                  </Row>

                  {/* ====== Mother's Details ====== */}
                  <Title level={4}>
                    Mother’s Information{' '}
                    <span style={{ fontWeight: 'normal' }}>(ತಾಯಿಯ ಮಾಹಿತಿ)</span>
                    -
                  </Title>
                  <Row
                    gutter={[16, 0]}
                    className="my-2 p-2 rounded border"
                    style={{ backgroundColor: '#f2f7fdff' }}
                  >
                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="First Name (ಮೊದಲ ಹೆಸರು)"
                        rules={[{ required: true }]}
                      >
                        <Input
                          size="large"
                          value={motherFirstName}
                          onChange={(e) => setMotherFirstName(e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Middle Name (ಮಧ್ಯದ ಹೆಸರು)"
                        rules={[{ required: true }]}
                      >
                        <Input
                          size="large"
                          value={motherMiddleName}
                          onChange={(e) => setMotherMiddleName(e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Last Name (ಕೊನೆಯ ಹೆಸರು)"
                        rules={[{ required: true }]}
                      >
                        <Input
                          size="large"
                          value={motherLastName}
                          onChange={(e) => setMotherLastName(e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={6}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Mobile (ಮೊಬೈಲ್)"
                        validateStatus={motherMobileError ? 'error' : ''}
                        help={motherMobileError}
                        rules={[
                          {
                            required: true,
                            message: 'Please enter mobile number',
                          },
                          {
                            pattern: /^[6-9]\d{9}$/,
                            message:
                              'Please enter a valid 10-digit mobile number',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter 10-digit mobile number"
                          size="large"
                          maxLength={10}
                          value={motherMob}
                          onChange={(e) => {
                            const value = e.target.value
                              .replace(/\D/g, '')
                              .slice(0, 10)
                            setMotherMob(value)

                            if (value.length < 10) {
                              setMotherMobileError(
                                'Mobile number must be 10 digits',
                              )
                            } else {
                              setMotherMobileError('')
                            }
                          }}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault() // ⛔ Prevents non-numeric input
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={6}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Age (ವಯಸ್ಸು)"
                        rules={[
                          { required: true, message: 'Please enter age' },
                          {
                            pattern: /^(?:[1-9][0-9]?|100)$/,
                            message: 'Please enter a valid age (1–100)',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter age"
                          size="large"
                          value={motherAge}
                          onChange={(e) => setMotherAge(e.target.value)}
                          maxLength={3}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault() // ⛔ blocks non-numeric input
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={6}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Occupation (ಉದ್ಯೋಗ)"
                        rules={[
                          {
                            required: true,
                            message: 'Please select occupation',
                          },
                        ]}
                      >
                        <Select
                          size="large"
                          value={motherOccupation}
                          onChange={(value) => setMotherOccupation(value)}
                          placeholder="Select Occupation"
                        >
                          <Select.Option value="Business">
                            Business
                          </Select.Option>
                          <Select.Option value="House Wife">
                            House Wife
                          </Select.Option>
                          <Select.Option value="Farmer">Farmer</Select.Option>
                          <Select.Option value="Professional">
                            Professional
                          </Select.Option>
                          <Select.Option value="Trader">Trader</Select.Option>
                          <Select.Option value="Private Job">
                            Private Job
                          </Select.Option>
                          <Select.Option value="Govt Job">
                            Govt Job
                          </Select.Option>
                          <Select.Option value="Retired">Retired</Select.Option>
                          <Select.Option value="Unemployed">
                            Unemployed
                          </Select.Option>
                          <Select.Option value="Teacher">Teacher</Select.Option>
                          <Select.Option value="Doctor">Doctor</Select.Option>
                          <Select.Option value="Advocate">
                            Advocate
                          </Select.Option>
                          <Select.Option value="Others">Others</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>

                  {/* ====== Emergency Details ====== */}
                  <Title level={4}>
                    Emergency Contact Info{' '}
                    <span style={{ fontWeight: 'normal' }}>
                      (ತುರ್ತು ಸಂಪರ್ಕ ಮಾಹಿತಿ)
                    </span>
                    -
                  </Title>

                  <Row
                    gutter={[16, 0]}
                    className="my-2 p-2 rounded border"
                    style={{ backgroundColor: '#f2f7fdff' }}
                  >
                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Name (ಹೆಸರು)"
                        rules={[{ required: true }]}
                      >
                        <Input
                          size="large"
                          value={emergencyName}
                          onChange={(e) => setEmergencyName(e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={6}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Mobile (ಮೊಬೈಲ್)"
                        validateStatus={emergencyMobileError ? 'error' : ''}
                        help={emergencyMobileError}
                        rules={[
                          {
                            required: true,
                            message: 'Please enter mobile number',
                          },
                          {
                            pattern: /^[6-9]\d{9}$/,
                            message:
                              'Please enter a valid 10-digit mobile number',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter 10-digit mobile number"
                          size="large"
                          maxLength={10}
                          value={emergencyMobile}
                          onChange={(e) => {
                            const value = e.target.value
                              .replace(/\D/g, '')
                              .slice(0, 10)
                            setEmergencyMobile(value)

                            if (value.length < 10) {
                              setEmergencyMobileError(
                                'Mobile number must be 10 digits',
                              )
                            } else {
                              setEmergencyMobileError('')
                            }
                          }}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault() // ⛔ Prevents non-numeric input
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row justify="center" gutter={16}>
                    <Col>
                      <Button onClick={goPrevTab}>Back</Button>
                    </Col>
                    <Col>
                      <Button
                        onClick={goNextTab}
                        type="primary"
                        disabled={
                          !!fatherMobileError ||
                          !!motherMobileError ||
                          !!emergencyMobileError
                        }
                      >
                        Next
                      </Button>
                    </Col>
                  </Row>
                </Tabs.TabPane>

                <Tabs.TabPane tab="Reference Details" key="4">
                  <Title level={4}>
                    Temple Chairman Details{' '}
                    <span style={{ fontWeight: 'normal' }}>
                      (ದೇವಾಲಯ ಅಧ್ಯಕ್ಷರ ವಿವರ)
                    </span>
                  </Title>

                  <Row
                    gutter={[16, 0]}
                    className="my-2 p-2 rounded border"
                    style={{ backgroundColor: '#f2f7fdff' }}
                  >
                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Chairman Name (ಅಧ್ಯಕ್ಷರ ಹೆಸರು)"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter chairman name',
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          placeholder="Enter chairman name"
                          value={chairmanName}
                          onChange={(e) => setChairmanName(e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Mobile (ಮೊಬೈಲ್)"
                        validateStatus={chairmanMobileError ? 'error' : ''}
                        help={chairmanMobileError}
                        rules={[
                          {
                            required: true,
                            message: 'Please enter mobile number',
                          },
                          {
                            pattern: /^[6-9]\d{9}$/,
                            message:
                              'Please enter a valid 10-digit mobile number',
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          placeholder="Enter mobile number"
                          maxLength={10}
                          value={chairmanMobile}
                          onChange={(e) => {
                            const value = e.target.value
                              .replace(/\D/g, '')
                              .slice(0, 10)
                            setChairmanMobile(value)

                            if (value.length < 10) {
                              setChairmanMobileError(
                                'Mobile number must be 10 digits',
                              )
                            } else {
                              setChairmanMobileError('')
                            }
                          }}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) e.preventDefault()
                          }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Village (ಗ್ರಾಮ)"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter village name',
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          placeholder="Enter village"
                          value={chairmanVillage}
                          onChange={(e) => setChairmanVillage(e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Title level={4}>
                    Village Local Known Reference{' '}
                    <span style={{ fontWeight: 'normal' }}>
                      (ಗ್ರಾಮದ ಸ್ಥಳೀಯ ಪರಿಚಿತ ವ್ಯಕ್ತಿ)
                    </span>
                  </Title>

                  <Row
                    gutter={[16, 0]}
                    className="my-2 p-2 rounded border"
                    style={{ backgroundColor: '#f2f7fdff' }}
                  >
                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Reference Name (ಪರಿಚಿತ ವ್ಯಕ್ತಿಯ ಹೆಸರು)"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter reference name',
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          placeholder="Enter reference name"
                          value={localRefName}
                          onChange={(e) => setLocalRefName(e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Mobile (ಮೊಬೈಲ್)"
                        validateStatus={localRefMobileError ? 'error' : ''}
                        help={localRefMobileError}
                        rules={[
                          {
                            required: true,
                            message: 'Please enter mobile number',
                          },
                          {
                            pattern: /^[6-9]\d{9}$/,
                            message:
                              'Please enter a valid 10-digit mobile number',
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          placeholder="Enter mobile number"
                          maxLength={10}
                          value={localRefMobile}
                          onChange={(e) => {
                            const value = e.target.value
                              .replace(/\D/g, '')
                              .slice(0, 10)
                            setLocalRefMobile(value)

                            if (value.length < 10) {
                              setLocalRefMobileError(
                                'Mobile number must be 10 digits',
                              )
                            } else {
                              setLocalRefMobileError('')
                            }
                          }}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) e.preventDefault()
                          }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Relation / Identity (ಪರಿಚಯ)"
                        rules={[
                          { required: true, message: 'Please enter relation' },
                        ]}
                      >
                        <Input
                          size="large"
                          placeholder="e.g. Village Head, Neighbor"
                          value={localRefRelation}
                          onChange={(e) => setLocalRefRelation(e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Title level={4}>
                    Local Guardian (Belagavi Resident){' '}
                    <span style={{ fontWeight: 'normal' }}>
                      (ಸ್ಥಳೀಯ ಗಾರ್ಡಿಯನ್ (ಬೆಳಗಾವಿ ನಿವಾಸಿ))
                    </span>
                  </Title>

                  <Row
                    gutter={[16, 0]}
                    className="my-2 p-2 rounded border"
                    style={{ backgroundColor: '#f2f7fdff' }}
                  >
                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Name (ಹೆಸರು)"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter name',
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          placeholder="Enter name"
                          value={localGuardianName}
                          onChange={(e) => setLocalGuardianName(e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Mobile (ಮೊಬೈಲ್)"
                        validateStatus={localGuardianMobileError ? 'error' : ''}
                        help={localGuardianMobileError}
                        rules={[
                          {
                            required: true,
                            message: 'Please enter mobile number',
                          },
                          {
                            pattern: /^[6-9]\d{9}$/,
                            message:
                              'Please enter a valid 10-digit mobile number',
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          placeholder="Enter mobile number"
                          maxLength={10}
                          value={localGuardianMobile}
                          onChange={(e) => {
                            const value = e.target.value
                              .replace(/\D/g, '')
                              .slice(0, 10)
                            setLocalGuardianMobile(value)

                            if (value.length < 10) {
                              setLocalGuardianMobileError(
                                'Mobile number must be 10 digits',
                              )
                            } else {
                              setLocalGuardianMobileError('')
                            }
                          }}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) e.preventDefault()
                          }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Belagavi Address (ಬೆಳಗಾವಿ ವಿಳಾಸ)"
                        rules={[
                          { required: true, message: 'Please enter address' },
                        ]}
                      >
                        <Input
                          size="large"
                          placeholder="Enter address"
                          value={localGuardianAddress}
                          onChange={(e) =>
                            setLocalGuardianAddress(e.target.value)
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row justify="center" gutter={16}>
                    <Col>
                      <Button onClick={goPrevTab}>Back</Button>
                    </Col>
                    <Col>
                      <Button
                        onClick={goNext}
                        type="primary"
                        disabled={
                          !!chairmanMobileError ||
                          !!localRefMobileError ||
                          !!localGuardianMobileError
                        }
                      >
                        Next
                      </Button>
                    </Col>
                  </Row>
                </Tabs.TabPane>
              </Tabs>
            </>
          )}

          {step === 2 && (
            <>
              {/* ====== Academic Details ====== */}
              <Title level={4}>
                Academic Information{' '}
                <span style={{ fontWeight: 'normal' }}>(ಶೈಕ್ಷಣಿಕ ಮಾಹಿತಿ)</span>-
              </Title>
              <Row
                gutter={[16, 0]}
                className="my-2 p-2 rounded border"
                style={{ backgroundColor: '#f2f7fdff' }}
              >
                <Col xs={24} sm={12}>
                  <Form.Item noStyle>
                    <div style={{ marginBottom: 8, fontWeight: 500 }}>
                      Name of School / College Last Attended &nbsp;
                      <span style={{ fontSize: 12 }}>
                        (ಕೊನೆಯದಾಗಿ ವ್ಯಾಸಂಗ ಮಾಡಿದ ಶಾಲೆ / ಕಾಲೇಜಿನ ಹೆಸರು)
                      </span>
                    </div>

                    <Form.Item
                      rules={[{ required: true }]}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <Input
                        placeholder="College name"
                        size="large"
                        value={lastAttendedCollege}
                        onChange={(e) => setLastAttendedCollege(e.target.value)}
                      />
                    </Form.Item>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item noStyle>
                    <div style={{ marginBottom: 8, fontWeight: 500 }}>
                      Highest Qualification Obtained &nbsp;
                      <span style={{ fontSize: 12 }}>
                        (ಅತ್ಯುನ್ನತ ಅರ್ಹತೆ ಪಡೆದಿದ್ದಾರೆ)
                      </span>
                    </div>

                    <Form.Item
                      rules={[{ required: true }]}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <Select
                        size="large"
                        value={highestQualification}
                        onChange={(value) => setHighestQualification(value)}
                        placeholder="Select Highest Qualification"
                      >
                        <Select.Option value="SSC">SSC</Select.Option>
                        <Select.Option value="HSC">HSC</Select.Option>
                        <Select.Option value="DIPLOMA">DIPLOMA</Select.Option>
                        <Select.Option value="ITI">ITI</Select.Option>
                        <Select.Option value="GRADUATE">GRADUATE</Select.Option>
                        <Select.Option value="POST GRADUATE">
                          POST GRADUATE
                        </Select.Option>
                      </Select>
                    </Form.Item>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8}>
                  <Form.Item noStyle>
                    <div style={{ marginBottom: 8, fontWeight: 500 }}>
                      Specific Degree &nbsp;
                      <span style={{ fontSize: 12 }}>(ನಿರ್ದಿಷ್ಟ ಪದವಿ)</span>
                    </div>

                    <Form.Item
                      rules={[{ required: true }]}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <Input
                        placeholder="e.g. BCA, MCA, B.Sc, M.Sc etc."
                        size="large"
                        value={specificDegree}
                        onChange={(e) => setSpecificDegree(e.target.value)}
                      />
                    </Form.Item>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8}>
                  <Form.Item noStyle>
                    <div style={{ marginBottom: 8, fontWeight: 500 }}>
                      Aggregate Percentage (%) &nbsp;
                      <span style={{ fontSize: 12 }}>
                        (ಒಟ್ಟು ಶೇಕಡಾವಾರು (%))
                      </span>
                    </div>

                    <Form.Item
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      rules={[{ required: true }]}
                    >
                      <Select
                        size="large"
                        placeholder="Select Percentage"
                        options={percentageOptions}
                        value={aggregatePercentage}
                        onChange={(value) => setAggregatePercentage(value)}
                        style={{ width: '100%' }}
                        showSearch
                        optionFilterProp="label"
                      />
                    </Form.Item>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8}>
                  <Form.Item noStyle>
                    <div style={{ marginBottom: 8, fontWeight: 500 }}>
                      Month & Year of Passing &nbsp;
                      <span style={{ fontSize: 12 }}>
                        (ತೇರ್ಗಡೆಯಾದ ತಿಂಗಳು ಮತ್ತು ವರ್ಷ)
                      </span>
                    </div>

                    <Form.Item rules={[{ required: true }]}>
                      <DatePicker
                        picker="month"
                        size="large"
                        style={{ width: '100%' }}
                        format="MM-YYYY"
                        placeholder="Select Month & Year"
                        value={
                          monthYearOfPassing
                            ? dayjs(monthYearOfPassing, 'MM-YYYY')
                            : null
                        }
                        onChange={(date, dateString) => {
                          setMonthYearOfPassing(dateString) // e.g. "06-2024"
                        }}
                      />
                    </Form.Item>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item noStyle>
                    <div style={{ marginBottom: 8, fontWeight: 500 }}>
                      Name of Institution Currently Enrolled In
                      <br />
                      <span style={{ fontSize: 12 }}>
                        (ಪ್ರಸ್ತುತ ದಾಖಲಾಗಿರುವ ಸಂಸ್ಥೆಯ ಹೆಸರು)
                      </span>
                    </div>
                    <Form.Item
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      rules={[{ required: true }]}
                    >
                      <Input
                        placeholder="College Name"
                        size="large"
                        value={currentCollege}
                        onChange={(e) => setCurrentCollege(e.target.value)}
                      />
                    </Form.Item>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={6}>
                  <Form.Item noStyle>
                    <div style={{ marginBottom: 8, fontWeight: 500 }}>
                      Course / Program Name &nbsp;
                      <span style={{ fontSize: 12 }}>
                        (ಕೋರ್ಸ್ / ಕಾರ್ಯಕ್ರಮದ ಹೆಸರು)
                      </span>
                    </div>
                    <Form.Item
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      rules={[{ required: true }]}
                    >
                      <Input
                        placeholder="e.g. BCA, MCA, B.Sc, M.Sc etc."
                        size="large"
                        value={courseName}
                        onChange={(e) => setCourseName(e.target.value)}
                      />
                    </Form.Item>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={6}>
                  <Form.Item noStyle>
                    <div style={{ marginBottom: 8, fontWeight: 500 }}>
                      Total Course Duration
                      <br />
                      <span style={{ fontSize: 12 }}>(ಒಟ್ಟು ಕೋರ್ಸ್ ಅವಧಿ)</span>
                    </div>
                    <Form.Item
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      rules={[{ required: true }]}
                    >
                      <Select
                        size="large"
                        placeholder="Select Duration"
                        options={durationOptions}
                        value={totalCourseDuration}
                        onChange={(value) => setTotalCourseDuration(value)}
                      />
                    </Form.Item>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={6}>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    label="Remaining Duration of Course (ಉಳಿದಿರುವ ಕೋರ್ಸ್ ಅವಧಿ)"
                    rules={[{ required: true }]}
                  >
                    <Select
                      size="large"
                      placeholder="Select Remaining Duration"
                      options={durationOptions}
                      value={remainingCourseDuration}
                      onChange={(value) => setRemainingCourseDuration(value)}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* ====== Next Button ====== */}
              <Row justify="center" gutter={16}>
                <Col>
                  <Button onClick={goBack}>Back</Button>
                </Col>
                <Col>
                  <Button onClick={goNext} type="primary">
                    Next
                  </Button>
                </Col>
              </Row>
            </>
          )}

          {step === 3 && (
            <>
              {/* ====== Student Documents ====== */}
              <Title level={4}>
                Student Document{' '}
                <span style={{ fontWeight: 'normal' }}>
                  (ವಿದ್ಯಾರ್ಥಿ ಡಾಕ್ಯುಮೆಂಟ್)
                </span>
                -
              </Title>
              <Row
                gutter={[16, 0]}
                className="my-2 p-2 rounded border"
                style={{ backgroundColor: '#f2f7fdff' }}
              >
                <Col xs={24} sm={8}>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    label="Profile Picture (ಪ್ರೊಫೈಲ್ ಚಿತ್ರ)"
                    rules={[{ required: true }]}
                  >
                    <Upload
                      accept="image/*"
                      beforeUpload={() => false}
                      fileList={profilePicFileList}
                      onChange={(e) => handleImageUpload1(e)}
                      listType="picture"
                      maxCount={1}
                      style={{ width: '100%' }}
                    >
                      <Button
                        icon={<UploadOutlined />}
                        size="large"
                        style={{ width: '100%' }}
                      >
                        Upload
                      </Button>
                    </Upload>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8}>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    label="Aadhar Card (ಆಧಾರ್ ಕಾರ್ಡ್)"
                    rules={[{ required: true }]}
                  >
                    <Upload
                      accept="image/*,.pdf"
                      beforeUpload={() => false}
                      fileList={aadharFileList}
                      onChange={(e) => handleImageUpload2(e)}
                      listType="picture"
                      maxCount={1}
                      style={{ width: '100%' }}
                    >
                      <Button
                        icon={<UploadOutlined />}
                        size="large"
                        style={{ width: '100%' }}
                      >
                        Upload
                      </Button>
                    </Upload>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8}>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    label="Cast Income Certificate (ಜಾತಿ ಆದಾಯ ಪ್ರಮಾಣಪತ್ರ)"
                    rules={[{ required: true }]}
                  >
                    <Upload
                      accept="image/*,.pdf"
                      beforeUpload={() => false}
                      fileList={casteFileList}
                      onChange={(e) => handleImageUpload3(e)}
                      listType="picture"
                      maxCount={1}
                      style={{ width: '100%' }}
                    >
                      <Button
                        icon={<UploadOutlined />}
                        size="large"
                        style={{ width: '100%' }}
                      >
                        Upload
                      </Button>
                    </Upload>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8}>
                  <div style={{ marginBottom: 8, fontWeight: 500 }}>
                    Format of Letter Of Recommendation
                    <br />
                    <span style={{ fontSize: 12 }}>(ಶಿಫಾರಸು ಪತ್ರದ ಸ್ವರೂಪ)</span>
                  </div>

                  <a href={NamunaForm} download>
                    <Button
                      type="primary"
                      size="large"
                      style={{ width: '100%' }}
                    >
                      Download Format
                    </Button>
                  </a>
                </Col>

                <Col xs={24} sm={8}>
                  <Form.Item noStyle>
                    <div style={{ marginBottom: 8, fontWeight: 500 }}>
                      Letter Of Recommendation From Local Jain Temple
                      <br />
                      <span style={{ fontSize: 12 }}>
                        (ಸ್ಥಳೀಯ ಜೈನ ದೇವಾಲಯದಿಂದ ಶಿಫಾರಸು ಪತ್ರ)
                      </span>
                    </div>

                    <Form.Item rules={[{ required: true }]}>
                      <Upload
                        accept="image/*,.pdf"
                        beforeUpload={() => false}
                        fileList={recommFileList}
                        onChange={(e) => handleImageUpload4(e)}
                        listType="picture"
                        maxCount={1}
                        style={{ width: '100%' }}
                      >
                        <Button
                          icon={<UploadOutlined />}
                          size="large"
                          style={{ width: '100%' }}
                        >
                          Upload
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8}>
                  <Form.Item noStyle>
                    <div style={{ marginBottom: 8, fontWeight: 500 }}>
                      Current Year School/Clg Admission Receipt
                      <br />
                      <span style={{ fontSize: 12 }}>
                        (ಪ್ರಸ್ತುತ ವರ್ಷದ ಶಾಲೆ/ಕ್ಲಾಸ್ ಪ್ರವೇಶ ರಶೀದಿ)
                      </span>
                    </div>

                    <Form.Item rules={[{ required: true }]}>
                      <Upload
                        accept="image/*,.pdf"
                        beforeUpload={() => false}
                        fileList={receiptFileList}
                        onChange={(e) => handleImageUpload5(e)}
                        listType="picture"
                        maxCount={1}
                        style={{ width: '100%' }}
                      >
                        <Button
                          icon={<UploadOutlined />}
                          size="large"
                          style={{ width: '100%' }}
                        >
                          Upload
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Form.Item>
                </Col>
              </Row>

              {/* ====== Next Button ====== */}
              <Row justify="center" gutter={16}>
                <Col>
                  <Button onClick={goBack}>Back</Button>
                </Col>
                <Col>
                  <Button onClick={goNext} type="primary">
                    Next
                  </Button>
                </Col>
              </Row>
            </>
          )}

          {step === 4 && (
            <>
              {/* ====== Payment Information ====== */}
              <Title level={4}>
                Payment Information{' '}
                <span style={{ fontWeight: 'normal' }}>(ಪಾವತಿ ಮಾಹಿತಿ)</span>-
              </Title>

              {/* ====== Payment Section ====== */}
              <Row
                gutter={[16, 0]}
                className="my-2 p-2 rounded border"
                style={{ backgroundColor: '#f2f7fdff' }}
              >
                <Col xs={24} sm={8}></Col>
                <Col xs={24} sm={8} className="pt-4">
                  <Form.Item
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    label="Payment Mode (ಪಾವತಿ ಮೋಡ್)"
                    rules={[{ required: true, message: 'Select payment mode' }]}
                  >
                    <Select
                      placeholder="Select payment mode"
                      size="large"
                      onChange={(value) => setPayMode(value)}
                    >
                      <Option value="1">Cash</Option>
                      <Option value="2">UPI</Option>
                      <Option value="3">Online</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}></Col>
                <Col xs={24} sm={8}></Col>
                <Col xs={24} sm={8} className="py-2 text-center">
                  {payMode == 2 && (
                    <>
                      <img
                        src={QRCodeImg}
                        alt="QR Code"
                        className="rounded shadow"
                        style={{
                          width: '200px',
                          height: '200px',
                          border: '1px solid #d1d1d1ff',
                        }}
                      />{' '}
                      <br />
                      <span>QR Code for payment</span>
                    </>
                  )}
                </Col>
                <Col xs={24} sm={8}></Col>
              </Row>

              {(payMode === '1' || payMode === '2' || payMode === '3') && (
                <Row
                  gutter={[16, 0]}
                  className="my-2 p-2 rounded border"
                  style={{ backgroundColor: '#f2f7fdff' }}
                >
                  {payMode === '1' && (
                    <>
                      <Col xs={24} sm={8}>
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          label="Amount (ಮೊತ್ತ)"
                        >
                          <Input readOnly size="large" value={amount} />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={8}>
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          label="Receipt ID (ರಶೀದಿ ಐಡಿ)"
                          rules={[
                            { required: true, message: 'Enter receipt ID' },
                          ]}
                        >
                          <Input
                            placeholder="Enter receipt ID"
                            size="large"
                            value={taxId}
                            onChange={(e) => setTaxId(e.target.value)}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={8}>
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          label="Payment Date (ಪಾವತಿ ದಿನಾಂಕ)"
                          rules={[
                            { required: true, message: 'Select payment date' },
                          ]}
                        >
                          <DatePicker
                            style={{ width: '100%' }}
                            format="DD-MM-YYYY"
                            onChange={(date) => setPaymentDate(date)}
                            size="large"
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={8}>
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          label="Upload Receipt Image (ರಶೀದಿ ಚಿತ್ರವನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ)"
                          rules={[{ required: true }]}
                        >
                          <Upload
                            accept="image/*,.pdf"
                            beforeUpload={() => false}
                            onChange={(e) => handleImageUpload6(e)}
                            listType="picture"
                            maxCount={1}
                            style={{ width: '100%' }}
                          >
                            <Button
                              icon={<UploadOutlined />}
                              size="large"
                              style={{ width: '100%' }}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>

                      {/* ====== Buttons ====== */}
                      <Col xs={24}>
                        <Row justify="center" gutter={16}>
                          <Col>
                            <Button onClick={goBack}>Back</Button>
                          </Col>

                          <Col>
                            <Button
                              type="primary"
                              htmlType="submit"
                              loading={loading}
                              onClick={handleSubmit}
                            >
                              Register
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </>
                  )}

                  {payMode === '2' && (
                    <>
                      <Col xs={24} sm={8}>
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          label="Amount (ಮೊತ್ತ)"
                        >
                          <Input readOnly size="large" value={amount} />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={8}>
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          label="UPI Transaction ID (UPI ವಹಿವಾಟು ಐಡಿ)"
                          rules={[
                            {
                              required: true,
                              message: 'Enter UPI transaction ID',
                            },
                          ]}
                        >
                          <Input
                            placeholder="Enter UPI Txn ID"
                            size="large"
                            value={taxId}
                            onChange={(e) => setTaxId(e.target.value)}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={8}>
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          label="Payment Date (ಪಾವತಿ ದಿನಾಂಕ)"
                          rules={[
                            { required: true, message: 'Select payment date' },
                          ]}
                        >
                          <DatePicker
                            style={{ width: '100%' }}
                            format="DD-MM-YYYY"
                            onChange={(date) => setPaymentDate(date)}
                            size="large"
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={8}>
                        <Form.Item noStyle>
                          <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Upload Payment Screenshot &nbsp;
                            <span style={{ fontSize: 12 }}>
                              (ಪಾವತಿಯ ಸ್ಕ್ರೀನ್‌ಶಾಟ್ ಅನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ)
                            </span>
                          </div>
                          <Form.Item
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            rules={[{ required: true }]}
                          >
                            <Upload
                              accept="image/*,.pdf"
                              beforeUpload={() => false}
                              fileList={taxFileList}
                              onChange={handleImageUpload6}
                              listType="picture"
                              maxCount={1}
                              style={{ width: '100%' }}
                            >
                              <Button
                                icon={<UploadOutlined />}
                                size="large"
                                style={{ width: '100%' }}
                              >
                                Upload
                              </Button>
                            </Upload>
                          </Form.Item>
                        </Form.Item>
                      </Col>

                      {/* ====== Buttons ====== */}
                      <Col xs={24}>
                        <Row justify="center" gutter={16}>
                          <Col>
                            <Button onClick={goBack}>Back</Button>
                          </Col>

                          <Col>
                            <Button
                              type="primary"
                              htmlType="submit"
                              loading={loading}
                              onClick={handleSubmit}
                            >
                              Register
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </>
                  )}

                  {payMode === '3' && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '20px',
                        marginTop: '20px',
                        width: '100%',
                      }}
                    >
                      {/* ====== Buttons ====== */}
                      <Col xs={24}>
                        <Row justify="center" gutter={16}>
                          <Col>
                            <Button onClick={goBack}>Back</Button>
                          </Col>

                          <Col>
                            <Button
                              type="primary"
                              style={{ backgroundColor: '#1677ff' }}
                              onClick={() =>
                                toast.info('Redirecting to online payment...')
                              }
                            >
                              Pay Now
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </div>
                  )}
                </Row>
              )}
            </>
          )}
        </div>
      </Content>

      <Footer />
    </Layout>
  )
}
